import { createAction, createReducer } from '@reduxjs/toolkit';

export interface LayoutState {
  /** Which layout scope is currently being edited, if any. Null = no edit mode active. */
  editScope: string | null;
}

const initialState: LayoutState = { editScope: null };

export const setLayoutEditScope = createAction<string | null>('layout/setEditScope');

const layoutReducer = createReducer(initialState, (builder) => {
  builder.addCase(setLayoutEditScope, (state, action) => {
    state.editScope = action.payload;
  });
});

export default layoutReducer;
